
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const deleteUser = createAsyncThunk(
  "deleteUser/deleteUser",
  async (payload, thunkAPI) => {
    try {
      console.log(payload)
     
      const response = await api.delete(`delete-account`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || "Unknown error",
      });
    }
  }
);

const deleteUserSlice = createSlice({
  name: "deleteUser",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
          

        state.loading = false;
        state.data = action.payload;
      })
      .addCase(deleteUser.rejected, (state, action) => {
       
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default deleteUserSlice.reducer;
